'use client';

import { useGetTransactionsQuery } from '~/redux/api/walletApiSlice';

export default function useWallet({
  locale = 'en',
  params = '',
}: {
  locale?: string;
  params?: string;
}) {
  const {
    data: walletData,
    isLoading,
    isSuccess,
    error,
    isFetching,
  } = useGetTransactionsQuery(
    { locale, params },
    {
      refetchOnMountOrArgChange: true,
    },
  );
  const walletBalance = walletData?.wallet?.balance ?? 0;
  const transactions = walletData?.transactions ?? [];
  const paginate = walletData?.paginate;
  const walletNotFound =
    (error as { status?: number } | undefined)?.status === 404;
  const userHasWallet = !walletNotFound;

  return {
    isWalletLoading: isLoading,
    isWalletSuccess: isSuccess || (userHasWallet ? !isFetching : true),
    isWalletFetching: isFetching,
    walletError: error,
    walletBalance: Number(walletBalance),
    transactions,
    hasSufficientBalance: Number(walletBalance) > 0,
    paginate,
    userHasWallet,
  };
}
